// extracted by mini-css-extract-plugin
export default {"pTop":"Uz0dxc23ehFUpY6GYFAp"};